module.exports = __webpack_public_path__ + "dedb5ebf609f116674d485a2edc9a67b.png";